import { CircleChevronDown } from 'lucide-react';

interface DropDownArrowProps {
  openDropdown: boolean;
  iconOpacity?: number;
  iconSize?: string;
}

const DropDownArrow = ({openDropdown, iconOpacity = 1, iconSize = "w-5 h-5"}: DropDownArrowProps) => {
  return <CircleChevronDown className={`${iconSize} !text-[#F05A24] transition-transform duration-200 ${openDropdown ? "rotate-180" : ""}`} style={{ opacity: iconOpacity }} />;
};

export default DropDownArrow;